import React, { FC } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";

export const FieldsGroup: FC = ({
  children
}) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2} className={classes.inputFields}>
      {children}
    </Grid>
  );
};

